import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WelcomeModule } from './welcome/welcome.module';
import { LoginModule } from './login/login.module';
import { FormsModule } from '@angular/forms';
import { SignupModule } from './signup/signup.module';
import { SharedModule } from 'src/app/modules/shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    WelcomeModule,
    LoginModule,
    SharedModule,
    FormsModule,
    SignupModule
  ],
  declarations: []
})
export class HomeModule { }
